import m from "mithril";

import { GridModel } from "gridModel";
import { GridViews } from "gridViews";

if (GridModel.vars.gridEl) {
    m.route.prefix = location.pathname + "#!";
    m.route(GridModel.vars.gridEl, "/1", {
        "/:viewState": GridViews.parentView,
        "/:viewState/:catId/:catName": GridViews.parentView,
    });
}
